import React, { Component } from 'react';

class FooterLink extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="footer-alt">
                    <p style={{color:'white'}} className="copy-rights">© {new Date().getFullYear()} <b>NIEC Indonesia</b>. All Rights Reserved. CV Naresy Indonesia</p>
                    <p style={{color:'white'}} className="copy-rights">Designed by NIEC IT Team</p>
                </div>
            </React.Fragment>
        );
    }
}

export default FooterLink;